"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddDisplayLocationDto = void 0;
class AddDisplayLocationDto {
    instanceId;
    coordinationEpoch;
    accuracy;
    altitude;
    altitudeAccuracy;
    heading;
    latitude;
    longitude;
    speed;
}
exports.AddDisplayLocationDto = AddDisplayLocationDto;
